import {
  cookieConfig, CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED,
} from "./storage.constants";
// import { consoleLogError, consoleLogInfo } from "../console";
import { dispatchCustomEvent } from "../dom";

export function getCookie(name, cookie, defaultValue) {
  if (!cookie) {
    return defaultValue;
  }
  const value = `; ${cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return defaultValue;
}

export function setCookie(name, value, maxAge = cookieConfig.maxAge, path = cookieConfig.path) {
  document.cookie = `${name}=${value};path=${path};max-age=${maxAge}`;
}

export function deleteCookie(name, path = cookieConfig.path) {
  if (typeof window !== "undefined") {
    document.cookie = name + "=; Path=" + path + "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}

const _emulatedItems = [];
export const _emulateStorage = {
  setItem: (name, value) => {
    _emulatedItems[name] = value;
  },
  getItem: (name) => {
    return _emulatedItems[name] || null;
  },
  removeItem: (name) => {
    delete _emulatedItems[name];
  },
  clear: () => {
    _emulatedItems.length = 0;
  }
};

// Fixes the crash of some Darryl's friend with an Ipad IOS 10.
export const _getSessionStorageSafe = () => {
  try {
    if (!navigator.cookieEnabled) {
      return _emulateStorage;
    }

    if (typeof sessionStorage === "object") {
      sessionStorage.setItem("sessionStorage", 1);
      sessionStorage.removeItem("sessionStorage");
    }
    return sessionStorage;
  } catch (error) {
    return _emulateStorage;
  }
};
// Fixes the crash of some Darryl's friend with an Ipad IOS 10.
export const _getLocalStorageSafe = () => {
  try {
    if (!navigator.cookieEnabled) {
      return _emulateStorage;
    }

    if (typeof localStorage === "object") {
      localStorage.setItem("localStorage", 1);
      localStorage.removeItem("localStorage");
    }
    return localStorage;
  } catch (error) {
    return _emulateStorage;
  }
};

export const localStorageSafe = _getLocalStorageSafe();
export const sessionStorageSafe = _getSessionStorageSafe();


export let estimate;

{
  function formatByteSize(bytes) {
    if(bytes < 1024) return bytes + " bytes";
    else if(bytes < 1048576) return(bytes / 1024).toFixed(3) + " KiB";
    else if(bytes < 1073741824) return(bytes / 1048576).toFixed(3) + " MiB";
    else return(bytes / 1073741824).toFixed(3) + " GiB";
  }

  function _getJSONSizeInBytes(obj) {
    var bytes = 0;

    function sizeOf(obj) {
      if(obj !== null && obj !== undefined) {
        switch(typeof obj) {
          case 'number':
            bytes += 8;
            break;
          case 'string':
            bytes += obj.length * 2;
            break;
          case 'boolean':
            bytes += 4;
            break;
          case 'object':
            var objClass = Object.prototype.toString.call(obj).slice(8, -1);
            if(objClass === 'Object' || objClass === 'Array') {
              for(var key in obj) {
                if(!obj.hasOwnProperty(key)) continue;
                sizeOf(obj[key]);
              }
            } else bytes += obj.toString().length * 2;
            break;
        }
      }
      return bytes;
    };

    return sizeOf(obj);
  }

  const _getStorageSizeUsed = (storage) => {
    let total = 0, size, key;

    for (key in storage) {
      if (storage.hasOwnProperty(key)) {
        // Each length is multiplied by 2 because
        // the char in javascript stores as UTF-16 (occupies 2 bytes)
        size = (storage[key].length + key.length) * 2;
        total += size;
      }
    }

    return total;
  };

  const _getStorageSizeAvailable = (storage) => {
    if (storage) {
      let i = 0;
      try {
        // Test up to 10 MB
        for (i = 250; i <= 100000; i += 250) {
          storage.setItem('test', new Array((i * 1024) + 1).join('a'));
        }
      } catch (e) {
        storage.removeItem('test');
        return (i - 250) * 1024;
      }
    }

    return null;
  };

  const _estimateStorageUsage = (storageName, storage) => {
    return {
      bytesUsed: formatByteSize(_getStorageSizeUsed(storage)),
      bytesAvailable: formatByteSize(_getStorageSizeAvailable(storage)),
    }
  };

  const _estimateSWStorageUsage = async () => {
    try {
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        const estimation = await navigator.storage.estimate();
        return {
          bytesUsage: estimation.usage,
          bytesQuota: estimation.quota,
        };
      }
    } catch (e) {
      // no-op
    }

    return null;
  };

  const _estimateMemoryCacheSize = () => {
    try {
      const MemoryCache = window.MemoryCacheHolder;

      return {
        bytesSize: _getJSONSizeInBytes(MemoryCache),
        length: Object.keys(MemoryCache).length,
      }
    } catch (e) {
      // no-op
    }
  }

  const _estimateReduxSize = () => {
    try {
      return {
        bytesSize: formatByteSize(_getJSONSizeInBytes(store.getState())),
      }
    } catch (e) {
      // no-op
    }
  }

  const _estimateLogSizes = () => {
    let lengthSearch, lengthNetwork, lengthOther;

    try {
      const value = localStorage.getItem("logSearch");

      if (value) {
        lengthSearch = JSON.parse(value).length;
      }
    } catch(e) {
      // no-op
    }

    try {
      const value = localStorage.getItem("logNetwork");

      if (value) {
        lengthNetwork = JSON.parse(value).length;
      }
    } catch(e) {
      // no-op
    }

    try {
      const value = localStorage.getItem("logOther");

      if (value) {
        lengthOther = JSON.parse(value).length;
      }
    } catch(e) {
      // no-op
    }

    return {
      lengthSearch,
      lengthNetwork,
      lengthOther,
    };
  };

  const _estimateJSUse = () => {
    try {
      const out = {};

      for (const memoryKey in performance.memory) {
        out[memoryKey] = performance.memory[memoryKey];
      }

      return out;
    } catch (e) {
      // no-op
      return null;
    }
  };

  estimate = async () => {
    return {
      localStorage: _estimateStorageUsage("localStorage", localStorage),
      sessionStorage: _estimateStorageUsage("sessionStorage", sessionStorage),
      memoryCache: _estimateMemoryCacheSize(),
      redux: _estimateReduxSize(),
      logSizes: _estimateLogSizes(),
      jsUse: _estimateJSUse(),
      serviceWorker: await _estimateSWStorageUsage(),
    };
  };
}


export const clearStorage = (storage, keysToIgnore) => {
  Object.keys(storage).forEach((key) => {
    const removeKey = !keysToIgnore || !keysToIgnore.includes(key);

    if (removeKey) {
      storage.removeItem(key);
    }
  });
};

export const getStorageItem = (storage, key, defValue, stringify = true) => {
  const stored = storage.getItem(key);

  if (stored === undefined || stored === null) {
    return defValue;
  }

  if (!stringify) {
    return stored;
  }

  try {
    const parsed = JSON.parse(stored);
    return parsed ? JSON.parse(stored) : defValue;
  } catch (e) {
    return defValue;
  }
};
export const setStorageItem = (storage, key, value, stringify) => {
  try {
    if (value) {
      storage.setItem(key, stringify ? JSON.stringify(value) : value);
    } else {
      storage.removeItem(key);
    }
  } catch (error) {
    if (error && error.code === error.QUOTA_EXCEEDED_ERR) {
      // consoleLogInfo("Storage Quota exceeded", "Caught error, dispatched window custom event!", {
      //   storage, key, value, stringify,
      // });

      dispatchCustomEvent(CUSTOM_EVENT_STORAGE_QUOTA_EXCEEDED, {
        storage,
        cb: () => {
          setStorageItem(storage, key, value, stringify);
        },
      });

      return;
    }
    //
    // consoleLogError("Storage", "Set item - Unhandled ERROR: ", {
    //   error,
    //   storage, key, value, stringify,
    // });
  }
};

export const getLocalStorageItem = (key, defValue, stringify) => {
  return getStorageItem(localStorageSafe, key, defValue, stringify);
};

export const setLocalStorageItem = (key, value, stringify) => {
  return setStorageItem(localStorageSafe, key, value, stringify);
};

export const getSessionStorageItem = (key, defValue, stringify) => {
  return getStorageItem(sessionStorageSafe, key, defValue, stringify);
};

export const setSessionStorageItem = (key, value, stringify) => {
  return setStorageItem(sessionStorageSafe, key, value, stringify);
};
